import { JSX, useMemo } from "react";

import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { Alert, Typography, Box, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useEventForecastQuery } from "src/api/locationChartQueries.api";
import { getTomorrow } from "src/lib/date.helper";
import { type LocationModel } from "src/types/location";

import { getStyles } from "../info.styles";

function NextEventInfo({ selectedLocation }: { selectedLocation: LocationModel }): JSX.Element | null {
  const { t } = useTranslation();
  const theme = useTheme();
  const tomorrow = useMemo(() => getTomorrow(), []);
  const { data } = useEventForecastQuery(selectedLocation, tomorrow);

  const event = data?.value?.[0];

  if (!event?.Description || !event?.MeasureTime) return null;

  let eventDescription = event.Description ?? "";

  eventDescription = eventDescription.charAt(0).toUpperCase() + eventDescription.slice(1);

  const eventMeasureTime = dayjs(event.MeasureTime);

  const eventDay = eventMeasureTime?.format("D ") ?? "";
  const eventMonth = eventMeasureTime?.format ? t(eventMeasureTime.format("MMM")) : "";

  const eventWeekday = eventMeasureTime?.format("ddd") ?? "";
  const translatedWeekday = t(eventWeekday);

  return (
    <Alert
      severity='success'
      icon={<AutoFixHighIcon fontSize='small' />}
      sx={getStyles(theme).alert}
      action={
        <Typography variant='body2' sx={getStyles(theme).actionText}>
          <Box component='span' sx={getStyles(theme).truncatedRightText}>
            {eventDescription}
          </Box>
          <Box component='span'>{`, ${translatedWeekday} ${eventDay}${eventMonth}`}</Box>
        </Typography>
      }
    >
      <Typography variant='body2'>{t("Next event")}</Typography>
    </Alert>
  );
}

export default NextEventInfo;
